<template>
  <div class="project-transaction">
    <div class="opreationBox clearfix">
      <el-form
        :inline="true"
        :model="form"
        class="demo-form-inline"
        label-width="120px"
      >
        <el-form-item label="交易时间">
          <el-date-picker
            v-model="createTime"
            type="daterange"
            @change="changeTime"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="">
          <el-button
            style="width:98px"
            type="primary"
            @click="pageChange(1)"
          >查询
          </el-button>
          <el-button
            style="width:98px"
            type="danger"
            plain
            @click="reset"
          >重置
          </el-button>
        </el-form-item>
        <el-form-item label="" class="fr">
          <el-button
            style="width:98px;"
            type="primary"
            @click="exportList"
          >
            导出记录
          </el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="tableBox">
      <el-table
        v-loading="loading"
        :height="tableH"
        :data="dataList"
        border
        style="width: 100%"
      >
        <el-table-column
          header-align="center"
          prop="questionnaireId"
          label="问卷ID"
          width="120"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          prop="questionnaireTitle"
          label="问卷名称"
          width="180"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="panelName"
          label="微信名"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="amount"
          label="金额(元)"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="transferTime"
          label="交易时间"
        >
        </el-table-column>
      </el-table>
    </div>
    <div class="pageBox">
      <el-pagination
        background
        @size-change="pageSizeChange"
        @current-change="pageChange"
        :current-page="form.PageIndex"
        :page-sizes="[2, 4, 10, 20, 50, 100]"
        :page-size="form.PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import {launchDetailList,dowloadLaunchDetailList} from 'api/request'
  import {SetTableH} from '../../utils/utils'
  import moment from 'moment'

  export default {
    data() {
      return {
        loading: true,
        tableH: '250',
        createTime: '',
        form: {
          StartTime: '',
          EndTime: '',
          PageIndex: 1,
          PageSize: 10
        },
        total: 0,
        dataList: [],
        fileList: []
      }
    },
    components: {},
    methods: {
      pageSizeChange(val) {
        this.form.PageSize = val
        this.getList()
      },
      pageChange(val) {
        this.form.PageIndex = val
        this.getList()
      },
      async getList() {
        this.loading = true
        let data = await launchDetailList(this.form)
        if (data) {
          this.dataList = data.rows
          this.total = data.total
          this.loading = false
        }
      },
      changeTime(val) {
        this.form.StartTime = ''
        this.form.EndTime = ''
        if (val) {
          this.form.StartTime =  moment(val[0]).format('YYYY-MM-DD') + ' 00:00:00'
          this.form.EndTime =  moment(val[1]).format('YYYY-MM-DD') + ' 23:59:59'
        }
      },
      reset() {
        for (let key in this.form) {
          this.form[key] = ''
        }
        this.createTime = ''
        this.form.PageIndex = 1
        this.form.PageSize = 10
        this.getList()
      },
      async exportList() {
        try {
          const data = await dowloadLaunchDetailList(this.common.dealObjectValue(this.form))
          const blob = new Blob([data.data], { type: '.xlsx' }) // 构造一个blob对象来处理数据，并设置文件类型
          if (window.navigator.msSaveOrOpenBlob) { // 兼容IE10
            navigator.msSaveBlob(blob, '项目交易记录.xlsx')
          } else {
            const href = URL.createObjectURL(blob) // 创建新的URL表示指定的blob对象
            const a = document.createElement('a') // 创建a标签
            a.style.display = 'none'
            a.href = href // 指定下载链接
            a.download = '项目交易记录.xlsx' // 指定下载文件名
            a.click() // 触发下载
            URL.revokeObjectURL(a.href) // 释放URL对象
          }
        } catch (e) {
          console.log(e)
        }
      }
    },
    mounted() {
      SetTableH(this)
    },
    created() {
      this.getList()
    }
  }
</script>
<style lang='scss'>
  .project-transaction {
    .clearfix {
      &:after {
        content: "";
        display: table;
        clear: both;
      }
    }
    .fl{
      float: left;
    }
    .fr{
      float: right;
    }
    height: 100%;
    width: 100%;
    
    .formBox {
      width: 200px;
    }
    
    .pageBox {
      margin-top: 20px;
      text-align: right;
    }
    
    .dialog-footer {
      text-align: center;
    }
    
    .el-upload {
      display: block;
      margin: 0 auto;
      
      .el-upload-dragger {
        margin: 0 auto;
        width: 100%;
      }
    }
  }
</style>
